import { render } from "./EstateResaleSection.vue?vue&type=template&id=4f6510b9&scoped=true"
import script from "./EstateResaleSection.vue?vue&type=script&lang=js"
export * from "./EstateResaleSection.vue?vue&type=script&lang=js"

import "./EstateResaleSection.vue?vue&type=style&index=0&id=4f6510b9&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6510b9"]])

export default __exports__